import React from 'react';
import useAuthenticationStore from './Store';
import VerifyEmailUpdate from './VerifyEmailUpdate';

const VerifyEmailUpdateContainer: React.FC = () => {
  const { state } = useAuthenticationStore()
  const { serverError, isLoading } = state

  return (
    <VerifyEmailUpdate
      serverError={serverError}
      isLoading={isLoading}
    />
  )
}

export default VerifyEmailUpdateContainer